import { Plus } from "lucide-react";
import React from "react";
import { Link } from "react-router-dom";

function Card({ item }) {
  return (
    <div className="custom-category-card">
      <Link to={`/categories/${item?.slugPath || item?.slug}`} className="custom-category-image-container">
        
        {item?.image && (
         
            <img
              src={item.image}
              alt={item.name}
              className="custom-category-img"
            />
         
        )}

        {/* Text Overlay - Bottom Left */}
        <div className="custom-category-text-overlay">
          <Link
            to={`/categories/${item?.slugPath || item?.slug}`}
            className="custom-category-name text-decoration-none"
          >
            {item.name}
          </Link>
          <p className="custom-category-desc">{item.shortDescription}</p>
        </div>

        {/* Subtle Gradient for readability */}
        <div className="custom-category-gradient"></div>
      </Link>
    </div>
  );
}

export default Card;
